export default "__VITE_ASSET__76982496__"